import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { ReportesDef } from "./ReportesDef";

export const ReportesIcon = IconDashboard;
export const ReportesHelpText = '* Reportes.';

export class Reportes extends Entity<ReportesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ReportesDef(), parentKeys);
        this.Form = import('./ReportesForm').then((module) => module.ReportesForm);
        this.Title = "Exportación de Datos";
        this.HelpText = ReportesHelpText;
        this.Icon = ReportesIcon;
    }
}